angular.module('impactx.tender').controller('TenderContractTypeListCtrl', TenderContractTypeListCtrl);

function TenderContractTypeListCtrl() {
    var buttonDefinition = [];

    this.meta = {
        rowTemplate: 'modules/tender/templates/tendercontracttypelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/tender/contracttype/list',
        id: "tendercontracttype",
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    };
}